import React, { useEffect, useState, useRef } from 'react';
import { Routes, useNavigate, useLocation } from "react-router-dom";

import routes from '../libs/routes';
import images from "../libs/images";
import * as API from "../libs/service";

import { useDispatch, useSelector } from 'react-redux';

import { loadingStart, loadingEnd } from "../redux/loadingSlice";
import { open, close } from "../redux/popupSlice";

import Popup01 from "../pages/popup/Popup01"
import Popup02 from "../pages/popup/Popup02"
import PopupPlanModel from "../pages/popup/PopupPlanModel"
import PopupProfileEdit from "../pages/popup/PopupProfileEdit"
import PopupRegisterCoupon from "../pages/popup/PopupRegisterCoupon"


export default function MyCard1({ mainCard={}, DeleteCard=()=>{} }) {
    const location = useLocation();
    
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { mbData } = useSelector((s) => s.usersReducer);
    const lang = useSelector(state => state.langReducer.lang);

    const [otherPop, setOtherPop] = useState(false);
    //const [mainCard, setMainCard] = useState(mainCard);

    const popRef = useRef(null);

    useEffect(() => {
        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, []);

    const handleOutsideClick = (event) => {
        console.log(event?.srcElement?.id);
        if(event?.srcElement?.id === 'cardDeletes'){
            return;
        }
        //if (popRef.current && !popRef.current.contains(event.target)) {
            setOtherPop(false);
        //}
    };


    return (
        <>
            <div className="card_list_box">
                <div className={`card_info ${mainCard ? 'on' : ''}`}>
                    <div className="card_title">
                        <img src={require("../assets/icon/Card.svg").default} />
                        <p>{mainCard?.cardName}</p>
                        <div 
                            className="other"
                            onClick={() => {
                                setOtherPop(false)
                            }}
                        >   
                            {mainCard && 
                                <p className="main_card_on">{lang === 0 ? '결제 카드' : 'Payment Card'}</p>
                            }
                            <img 
                                src={require("../assets/icon/other.svg").default}
                                onClick={(e) => {
                                    e.stopPropagation()
                                    setOtherPop(!otherPop)
                                }}
                            />

                            <div 
                                className={`other_pop ${otherPop ? 'show' : ''}`}
                            >
                                {!mainCard &&
                                    <p
                                        onClick={(e) => {
                                            e.stopPropagation()
                                            setOtherPop(false)
                                            //setMainCard(true)
                                        }}
                                    >
                                        결제카드로 변경
                                    </p>
                                }

                                <p
                                    onClick={(e) => {
                                        DeleteCard()
                                    }}
                                    id="cardDeletes"
                                >
                                    {lang === 0 ? '카드삭제' : 'Delete Card'}
                                </p>
                            </div>
                        </div>
                    </div>

                    {mainCard?.status*1 === 1 && 
                        <div className="card_err_box">
                            <img src={require("../assets/icon/card_err.svg").default} />
                            <div className="text_box">
                                <p>만료 또는 사용불가</p>
                                <span>기본 결제 카드 방법이 사용불가 상태입니다. 구독 중단을 방지하려면 다른 결제 방법으로 전환하세요.</span>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </>
    );
}
